class ThemePopup extends HTMLElement {
  constructor() {
    super();

    // Prende i dati dal dataset dell'elemento
    this.startDate = new Date(this.dataset.start);  // Data e ora di inizio
    this.endDate = new Date(this.dataset.end);      // Data e ora di fine
    this.delay = parseInt(this.dataset.delay, 10) * 1000; // Converti secondi in millisecondi
    this.popupId = this.dataset.id;

    // Eventi per chiudere il popup o salvare nel localStorage
    const closeButton = this.querySelector('#close-popup');
    const overlay = this.querySelector('#popup-overlay');
    const popupContent = this.querySelector('a');

    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.stopPropagation(); // Impedisci la propagazione del click
        this.closePopup();
      });
    }

    if (popupContent) {
      popupContent.addEventListener('click', () => this.savePopupInLocalStorage()); // Salva su click sul contenuto
    }

    // Chiude il popup se si clicca fuori dall'overlay
    if (overlay) {
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) {
          this.closePopup();
        }
      });
    }

    // Controlla se il popup è già stato mostrato
    if (this.shouldShowPopup()) {
      setTimeout(() => {
        this.showPopup();
      }, this.delay);
    }
  }

  connectedCallback() {
    // Controlla validità della data
    const now = new Date();
    if (now < this.startDate || now > this.endDate) {
      this.remove(); // Rimuovi il popup se fuori dalla validità
    }
  }

  showPopup() {
    // Aggiunge la classe 'opened' al popup per mostrarlo
    this.classList.add('opened');
  }

  closePopup() {
    // Rimuove la classe 'opened' dal popup per nasconderlo
    this.classList.remove('opened');
    this.savePopupInLocalStorage(); // Salva lo stato nel localStorage alla chiusura
  }

  shouldShowPopup() {
    const savedPopups = JSON.parse(localStorage.getItem('shownPopups')) || {};
    const savedData = savedPopups[this.popupId];

    // Se non è stato mostrato o i dati sono diversi (nuova versione del popup)
    return !savedData || JSON.stringify(savedData) !== JSON.stringify(this.getPopupData());
  }

  savePopupInLocalStorage() {
    let savedPopups = JSON.parse(localStorage.getItem('shownPopups')) || {};
    savedPopups[this.popupId] = this.getPopupData();
    localStorage.setItem('shownPopups', JSON.stringify(savedPopups));
  }

  getPopupData() {
    // Cattura i dati attuali del popup da salvare nel localStorage
    return {
      startDate: this.dataset.start,
      endDate: this.dataset.end,
      delay: this.dataset.delay
    };
  }
}

// Definisci il custom element
customElements.define('theme-popup', ThemePopup);